<script setup lang="ts">
import { Card, EmptyState } from '@taler/ui'
import { useI18n } from 'vue-i18n'
import NotificationItem from '@/features/notifications/components/NotificationItem.vue'
import type { Notification } from '../internal/types.ts'

defineProps<{
  notifications: readonly Notification[]
  activeLedgerId: string | undefined
  hasNextPage: boolean
  isFetchingNextPage: boolean
}>()
const emit = defineEmits<{ markRead: [notificationId: string]; fetchNextPage: [] }>()

const { t } = useI18n()
</script>

<template>
  <EmptyState
    v-if="notifications.length === 0"
    :title="t('notifications.emptyTitle')"
    :body="t('notifications.emptyBody')"
  />
  <Card v-else padding="none">
    <ul :aria-label="t('notifications.title')">
      <NotificationItem
        v-for="notification in notifications"
        :key="notification.id"
        :notification="notification"
        :active-ledger-id="activeLedgerId"
        @mark-read="emit('markRead', $event)"
      />
    </ul>
    <div
      v-if="hasNextPage"
      class="flex justify-center border-t border-[color:var(--color-border)] p-[var(--space-cell)]"
    >
      <button
        type="button"
        :disabled="isFetchingNextPage"
        class="min-h-[var(--density-target-min)] rounded-[var(--radius-control)] border border-[color:var(--color-border-control)] px-[var(--space-cell)] py-[var(--space-inline)] text-[length:var(--text-step-2)] text-[color:var(--color-text)] disabled:opacity-60"
        @click="emit('fetchNextPage')"
      >
        {{ isFetchingNextPage ? t('notifications.loadingMore') : t('notifications.loadMore') }}
      </button>
    </div>
  </Card>
</template>
